import { createStyles, makeStyles } from "@material-ui/core/styles";
import * as React from "react";

import { Theme } from "@material-ui/core";
import Props from "./index.d";

interface GFCFieldSet_Stepper extends Props {
  children: React.ReactNode;
}

const FieldSetHorizontal: React.FC<GFCFieldSet_Stepper> = (props) => <>{props.children}</>;

export default FieldSetHorizontal;
